<template>
    <div class="campus-form">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="400">
                    <v-card>
                        <v-toolbar card prominent color="primary" dark>
                            <v-toolbar-title class="body-2">{{ this.formTitle }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa-close</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-card-text>
                            <v-form ref="campusForm" v-model="validCampus">
                                <v-container fluid grid-list-xl>
                                    <v-layout align-center wrap>
                                        <v-flex xs12 sm12>
                                            <v-text-field
                                                v-model="campusItem.codigo"
                                                label="Código"
                                                :rules="codigoFieldRules"
                                                :error-messages="codigoFieldErrors"
                                                :counter="10"
                                                @keydown="codigoFieldErrors = []"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm12>
                                            <v-text-field
                                                v-model="campusItem.nombre"
                                                label="Nombre"
                                                :rules="nombreFieldRules"
                                                :error-messages="nombreFieldErrors"
                                                :counter="255"
                                                @keydown="nombreFieldErrors = []"
                                                @keypress.enter.prevent="saveForm()"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                            <v-btn
                                color="success"
                                flat
                                @click="saveForm()"
                                :disabled="disableSaveButton"
                                :loading="loading"
                                >Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
    </div>
</template>

<script>
/* eslint-disable */
    export default {
        props: {
            formTitle: String,
            initialItem: Object
        },
        data () {
            return {
                loading: false,
                validCampus: false,
                campusItem: {
                    codigo: '',
                    nombre: '',
                },
                codigoFieldRules: [
                    v => !!v || 'Debe proporcionar un código',
                    v => v.length <= 10 || 'El código solo puede contener 10 caracteres',
                ],
                codigoFieldErrors: [],
                nombreFieldRules: [
                    v => !!v || 'Debe proporcionar un nombre',
                    v => v.length <= 255 || 'El nombre solo puede contener 255 caracteres',
                ],
                nombreFieldErrors: [],
            }
        },
        computed: {

            isNewRecord() {
                return this.initialItem === null
            },

            showForm: {
                get: function() {
                    return true
                },
                set: function () {
                    return this.cancelForm()
                }
            },

            disableSaveButton() {
                return this.loading || (!this.validCampus)
            }
        },

        methods:{
            saveForm() {
                this.loading = true
                this.$refs.campusForm.validate()
                if (this.validCampus) {
					let campus = {
						codigo: this.campusItem.codigo,
						nombre: this.campusItem.nombre
					}
					if (!this.isNewRecord) {
						campus.id = this.initialItem.id
					}
                    this.$store.dispatch(this.isNewRecord ? "ADD_CAMPUS" : "UPDATE_CAMPUS", campus).then(
                        result => {
                        	if (!result) {//no hay coneccion con el servidor
                        		this.loading = false
                            }
                            if (result === null || result.status === 404 || result.status === 500) {
                                //cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe
                                this.$emit("formCanceled")
                            } else {
                                // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                                let { data, status } = result
                                if (status === 422) {
                                    data.forEach(error => {
                                        if (error.field === "codigo") {
                                            this.codigoFieldErrors.push(error.message)
                                        }
                                        if (error.field === "nombre") {
                                            this.nombreFieldErrors.push(error.message)
                                        }
                                    })
                                }
                            }
                            this.loading = false
                        }
                    )
                } else {
                    this.loading = false
                }
            },
            cancelForm() {
                this.$emit("formCanceled")
            }
        },

        created() {
            if (this.initialItem !== null) {
                // Cargando información del elemento a actualizar
                this.campusItem.codigo = this.initialItem.codigo
                this.campusItem.nombre = this.initialItem.nombre
            }
        },
    };
</script>
